import * as React from 'react';

import { Button, JumpTo, Pagination } from 'ui/components';
import messages from 'ui/components/displayMessages';

interface CardsListBottomBarProps {
    currentPage: number;
    onPageJump: (pageNumber: number) => void;
    onPageNavigate: (pageNumber: number) => void;
    loadMore: () => void;
    pageCount: number;
}

/**
 * The CardsListBottomBar allows selecting a page in a paginated list of Cards.
 */
export class CardsListBottomBar extends React.Component<CardsListBottomBarProps> {

    public render() {
        return (
            <>
                <div className='cards-list-bottom-bar d-flex justify-content-between mb-3'>
                    <div className='lxc-hide-mobile w-100 d-flex align-items-center'>
                        <Pagination
                            pageCount={this.props.pageCount}
                            currentPage={this.props.currentPage}
                            onPageSelect={this.props.onPageNavigate}
                        />
                        <div className='ml-auto'>
                            <JumpTo
                                pageCount={this.props.pageCount}
                                currentPage={this.props.currentPage}
                                onPageSelect={this.props.onPageJump}
                            />
                        </div>
                    </div>
                </div>
                <div className='d-md-none'>
                    {this.nextPageExists &&
                        <>
                            <hr className='divider mb-3' />
                            <Button
                                label={messages.showMoreResults}
                                onClick={this.props.loadMore}
                                fullWidth={true}
                            />
                        </>
                    }
                </div>
            </>
        );
    }

    private get nextPageExists() {
        return this.props.pageCount >= this.props.currentPage + 1;
    }
}
